import { connectAndForwardRef } from 'util/redux'
import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import selectCurrentConversationId from 'ducks/searches/selectors/selectCurrentConversationId'
import { doChangeEditorFocus } from 'ducks/editor/operations'
import { doAgentStartTicketTypingNotification } from 'ducks/collisions/actions'
import { selectIsChatAvailableForCurrentWidget } from 'ducks/widgets/selectors'
import BasicMessageComposerView from './view'

const select = state => ({
  accountChatRoomId: selectAccountChatRoomId(state),
  conversationId: selectCurrentConversationId(state),
  enabled: selectIsChatAvailableForCurrentWidget(state),
})

const perform = {
  setEditorFocus: doChangeEditorFocus,
  sendStartTypingNotification: doAgentStartTicketTypingNotification,
}

export default connectAndForwardRef(select, perform)(BasicMessageComposerView)
